<!-- ============================================
     KYC MODALS
============================================ -->
<!-- KYC Required Modal -->
<div class="modal fade" id="updateKyx" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
     aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Required</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <a class="btn btn-secondary" routerLink="/update-kyc" data-bs-dismiss="modal">Click Here</a>
        <p> to complete your KYC</p>
      </div>
    </div>
  </div>
</div>

<!-- KYC Pending Modal -->
<div class="modal fade" id="Kyxpending" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
     aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Pending</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <p>Awaiting KYC approval.</p>
        <p>Please contact us for further assistance!</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- KYC Rejected Modal -->
<div class="modal fade" id="Kyxrejected" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
     aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title fs-5" id="staticBackdropLabel">KYC Rejected</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <p>Your KYC has been rejected</p>
        <p>To update</p>
        <a class="btn btn-secondary" routerLink="/update-kyc">Click Here</a>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     BOOK GOLD MODAL
============================================ -->
<div class="modal fade" id="bookGoldModal" tabindex="-1" aria-labelledby="bookGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="bookGoldModalLabel">Book Gold</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="bookGoldForm" (ngSubmit)="onGoldSubmit('gold')">
          <div class="pop-up-gold">
            <!-- Image: /assets/goldone.png -->
            <img class="goldbars-img"  src="../../assets/goldbars.png" alt="Gold Icon" />
            <h6 class="heading-price-gram">Gold Live Price Per Gram</h6>
            <h4 class="price-popup-counter">₹ {{ stayBuyGoldRate }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align: left;">Price will be locked for : {{ timerBuy }} seconds</p>
          
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="">Quantity</option>
            <option *ngFor="let limit of goldMaxLimit" [value]="limit">{{ limit }} Grams</option>
          </select>
          
          <div class="validationError" *ngIf="bookGoldForm.get('quantity_purchased')?.hasError('required') && bookGoldForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          
          <br /><br />
          <p class="fixAmount">
            The maximum range for placing buy orders should be within a difference of <b>110 Rs</b> from the live gold price.
            For example, if the live gold price is 6200 Rs, users can place buy gold orders for 6090 Rs or more,
            which is acceptable. However, if the price falls below 6090 Rs, placing buy gold orders is not acceptable.
          </p>
          
          <input type="text" formControlName="book_rate" (input)="userAmount(bookGoldForm.get('book_rate')?.value)"
                 class="formselect-gold" placeholder="Enter your amount" />
          
          <div class="validationError" *ngIf="bookGoldForm.get('book_rate')?.hasError('required') && bookGoldForm.get('book_rate')?.touched">
            Amount is required.
          </div>
          <div class="validationError" *ngIf="bookGoldForm.get('book_rate')?.hasError('pattern') && bookGoldForm.get('book_rate')?.touched">
            Please enter a valid amount.
          </div>
          
          <button class="buy-gold-popup" *ngIf="bookGoldForm.invalid" [disabled]="true" type="button">Book</button>
          <button class="buy-gold-popup-valid" *ngIf="bookGoldForm.valid && isAmountLessThan110" type="submit" data-bs-dismiss="modal">Book</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     BUY GOLD MODAL
============================================ -->
<div class="modal fade" id="buyGoldModal" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel" style="color:black">Buy Gold</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="buyGoldForm" (ngSubmit)="onBuySubmit('Gold')">
          <div class="pop-up-gold">
  
            <img class="goldbars-img" src="../../assets/goldbars.png" alt="Gold Icon" />
            <h3 class="heading-price-gram">Gold Live Price Per Gram</h3>
            <h4 class="price-popup-counter">{{ stayBuyGoldRate | currency : "INR" : "symbol" : "1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align: left;">Price will be locked for : {{ timerBuy }} seconds</p>
          
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of goldMaxLimit" [value]="limit">{{ limit }} Grams</option>
          </select>
          
          <div class="validationError" *ngIf="buyGoldForm.get('quantity_purchased')?.hasError('required') && buyGoldForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          
          <button class="buy-gold-popup" *ngIf="buyGoldForm.invalid" [disabled]="true" type="button">Buy</button>
          <button class="buy-gold-popup-valid" *ngIf="buyGoldForm.valid" type="submit" data-bs-dismiss="modal">Buy</button>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="buyGoldModalNew" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog new-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel" style="color:black">What would you like to buy?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <!-- <p class="price-lock-text">Price locked for : {{ timerBuy }} seconds</p> -->
        <div class="buy-options-wrapper">
          <!-- Gold Coins Option -->
          <!-- <div class="buy-option-card" [class.selected]="selectedOption === 'coins'" (click)="selectOption('coins')">
            <div class="option-img-wrap coin-wrap">
              <img src="../../assets/images/Gold-coin.png" alt="Gold Coins" class="option-img" />
            </div>
            <h6 class="option-title">Gold Coins</h6>
            <p class="option-subtitle">Mix coin sizes,<br>min 100g</p>
          </div> -->

          <div class="buy-option-card"
     [class.selected]="selectedOption === 'coins'"
     (click)="selectOption('coins', 'Gold')">

  <div class="option-img-wrap coin-wrap">
    <img src="../../assets/images/Gold-coin.png" alt="Gold Coins" class="option-img" />
  </div>

  <h6 class="option-title">Gold Coins</h6>

  <p class="option-subtitle">
    Mix coin sizes,<br>min 100g
  </p>

</div>

          <!-- Gold Bars Option -->
          <!-- <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" data-bs-toggle="modal" data-bs-target="#buyGoldModal">
            <div class="option-img-wrap bar-wrap">
              <img src="../../assets/images/bars.png" alt="Gold Bars" class="option-img" />
            </div>
            <h6 class="option-title">Gold Bars</h6>
            <p class="option-subtitle">One solid bar,<br>pick a weight</p>
          </div> -->
          <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" (click)="switchToBuyGoldModal()">
  <div class="option-img-wrap bar-wrap">
    <img src="../../assets/images/bars.png" alt="Gold Bars" class="option-img" />
  </div>
  <h6 class="option-title">Gold Bars</h6>
  <p class="option-subtitle">One solid bar,<br>pick a weight</p>
</div>
        </div>
      </div>
    </div>
  </div>
</div>



//for-Silver//
<div class="modal fade"  id="buyGoldModalNewSilver" tabindex="-1" aria-labelledby="buyGoldModalLabel" aria-hidden="true">
  <div class="modal-dialog new-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buyGoldModalLabel" style="color:black">What would you like to buy?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <!-- <p class="price-lock-text">Price locked for : {{ timerBuy }} seconds</p> -->
        <div class="buy-options-wrapper">
          <!-- Gold Coins Option -->
          <!-- <div class="buy-option-card" [class.selected]="selectedOption === 'coins'" (click)="selectOption('coins')">
            <div class="option-img-wrap coin-wrap">
              <img src="../../assets/images/silvercoin.png" alt="Gold Coins" class="option-img" />
            </div>
            <h6 class="option-title">Gold Coins</h6>
            <p class="option-subtitle">Mix coin sizes,<br>min 100g</p>
          </div> -->

          <div class="buy-option-card"
     [class.selected]="selectedOption === 'coins'"
     (click)="selectOption('coins', 'Silver')">

  <div class="option-img-wrap coin-wrap">
    <img src="../../assets/images/silvercoin.png" alt="Silver Coins" class="option-img" />
  </div>

  <h6 class="option-title">Silver Coins</h6>

  <p class="option-subtitle">
    Mix coin sizes,<br>min 100g
  </p>

</div>

          <!-- Gold Bars Option -->
          <!-- <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" data-bs-toggle="modal" data-bs-target="#buyGoldModal">
            <div class="option-img-wrap bar-wrap">
              <img src="../../assets/images/bars.png" alt="Gold Bars" class="option-img" />
            </div>
            <h6 class="option-title">Gold Bars</h6>
            <p class="option-subtitle">One solid bar,<br>pick a weight</p>
          </div> -->
          <div class="buy-option-card" [class.selected]="selectedOption === 'bars'" (click)="switchToBuyGoldModalsilver()">
  <div class="option-img-wrap bar-wrap">
    <img src="../../assets/images/silvernewbar.png" alt="Gold Bars" class="option-img" />
  </div>
  <h6 class="option-title">Silver Bars</h6>
  <p class="option-subtitle">One solid bar,<br>pick a weight</p>
</div>
        </div>
      </div>
    </div>
  </div>
</div>





<!-- ============================================
     BOOK SILVER MODAL
============================================ -->
<div class="modal fade" id="bookSilverModal" tabindex="-1" aria-labelledby="bookSilverModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="bookSilverModalLabel">Book Silver</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="bookSilverForm" (ngSubmit)="onGoldSubmit('silver')">
          <div class="pop-up-gold">
            <!-- Image: /assets/Silverone.png -->
            <img class="goldbars-img"  src="../../assets/silverbars.png" alt="Silver Icon" />
            <h6 class="heading-price-gram">Silver Live Price Per 1kg</h6>
            <h4 class="price-popup-counter-second">{{ stayBuySilverRate | currency : "INR" : "symbol" : "1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align: left;">Price will be locked for : {{ timerBuy }} seconds</p>
          
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="">Quantity</option>
            <option *ngFor="let limit of silverMaxLimit" [value]="limit">{{ limit }} Grams</option>
          </select>
          
          <div class="validationError" *ngIf="bookSilverForm.get('quantity_purchased')?.hasError('required') && bookSilverForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          
          <br /><br />
          <p class="fixAmount">
            The maximum range for placing buy orders should be within a difference of <b>1000 Rs</b> from the live silver price.
            For example, if the live silver price is 90000 Rs, users can place buy silver orders for 89000 Rs or more,
            which is acceptable. However, if the price falls below 89000 Rs, placing buy silver orders is not acceptable.
          </p>
          
          <input type="text" formControlName="book_rate" (input)="userAmountSilver(bookSilverForm.get('book_rate')?.value)"
                 class="formselect-gold" placeholder="Enter your amount" />
          
          <div class="validationError" *ngIf="bookSilverForm.get('book_rate')?.hasError('required') && bookSilverForm.get('book_rate')?.touched">
            Amount is required.
          </div>
          <div class="validationError" *ngIf="bookSilverForm.get('book_rate')?.hasError('pattern') && bookSilverForm.get('book_rate')?.touched">
            Please enter a valid amount.
          </div>
          
          <button class="buy-gold-popup" *ngIf="bookSilverForm.invalid" [disabled]="true" type="button">Book</button>
          <button class="buy-gold-popup-valid" *ngIf="bookSilverForm.valid && isAmountLessThan1000" type="submit" data-bs-dismiss="modal">Book</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     BUY SILVER MODAL
============================================ -->
<div class="modal fade" id="buySilverModal" tabindex="-1" aria-labelledby="buySilverModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content checkColor">
      <div class="modal-header">
        <h5 class="modal-title myheading-models" id="buySilverModalLabel">Buy Silver</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="buyGoldForm" (ngSubmit)="onBuySubmit('Silver')">
          <div class="pop-up-gold">
            <!-- Image: /assets/Silverone.png -->
            <img class="goldbars-img"  src="../../assets/silverbars.png" alt="Silver Icon" />
            <h6 class="heading-price-gram">Silver Live Price Per 1kg</h6>
            <h4 class="price-popup-counter-second">{{ stayBuySilverRate | currency : "INR" : "symbol" : "1.0-2" }}</h4>
          </div>
          <p style="color:red;font-weight:600;text-align: left;">Price will be locked for : {{ timerBuy }} seconds</p>
          
          <select class="formselect-gold" formControlName="quantity_purchased">
            <option value="" disabled>Quantity</option>
            <option *ngFor="let limit of silverMaxLimit" [value]="limit">{{ limit }} Grams</option>
          </select>
          
          <div class="validationError" *ngIf="buyGoldForm.get('quantity_purchased')?.hasError('required') && buyGoldForm.get('quantity_purchased')?.touched">
            Quantity is required.
          </div>
          
          <button class="buy-gold-popup" *ngIf="buyGoldForm.invalid" [disabled]="true" type="button">Buy</button>
          <button class="buy-gold-popup-valid" *ngIf="buyGoldForm.valid" type="submit" data-bs-dismiss="modal">Buy</button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- ============================================
     DOWNLOAD SECTION
============================================ -->


<!-- ============================================
     LICENCE & CERTIFICATE SECTION
============================================ -->


<!-- ============================================
     CONTACT US SECTION
============================================ -->
<!-- <section class="our-products-section">
 
</section> -->








<div class="live-rates-section">

  <h2 class="main-title">
    Spot Real-Time Gold and Silver Live Prices
  </h2>

  <!-- Spot Cards -->
  <div class="spot-cards">

    <div class="spot-card gold">
      <div class="spot-header">SPOT GOLD</div>
      <div class="spot-value" [style.color]="spotGoldColor"> $ {{ spotGold | number: '1.2-2'}}</div>
    </div>

    <div class="spot-card silver">
      <div class="spot-header">SPOT SILVER</div>
      <div class="spot-value" [style.color]="spotSilverColor"> $ {{ spotSilver | number: '1.2-2'}}</div>
    </div>

    <div class="spot-card rupee">
      <div class="spot-header">SPOT RUPEE</div>
      <div class="spot-value" [style.color]="spotINRColor"> ₹ {{ spotINR | number: '1.2-2'}}</div>
    </div>

  </div>

  <div class="date-time">
    {{ now | customDateTime }}
  </div>

  <h2 class="commodity-title">
    Commodities on Gold Bharat
  </h2>

  <!-- Commodity Cards -->

  <div class="commodity-wrapper">
    
    <div class="commodity-wrapper-item">
      <!-- <div class="commodity-card gold-card">
        <div class="card-content">
        
          <p>Live Price Per Gram 999</p>

          <div class="price" *ngIf="!socketSubscription || !livePriceSubscription; else liveGoldRate"
            [style.color]="spotGoldColor">
            ₹ {{ spotGoldUpdate }}
          </div>
          <ng-template #liveGoldRate>
            <div class="price" [style.color]="spotGoldColor">₹ {{ spotGoldUpdate }}</div>
          </ng-template>
        </div>
      </div> -->
        <div class="commodity-card-gol" *ngIf="isLogin">
          <img class="new-gold-bg-img" src="../../assets/images/gol-bg.png">
        </div>
      <div class="commodity-card gold-card">
  <div class="card-content">

    <!-- Left Section -->
    <div class="price-section">
      <p>Live Price Per Gram</p>

      <div class="price"
           *ngIf="!socketSubscription || !livePriceSubscription; else liveGoldRate"
           [style.color]="spotGoldColor">
        ₹ {{ spotGoldUpdate }}
      </div>

      <ng-template #liveGoldRate>
        <div class="price" [style.color]="spotGoldColor">
          ₹ {{ spotGoldUpdate }}
        </div>
      </ng-template>
    </div>

    <!-- Right Section -->
    <div class="high-low-section">
      <div class="high-box">
        H {{ goldDayHigh | number:'1.0-0' }}
      </div>

      <div class="low-box">
        L {{ goldDayLow | number:'1.0-0' }}
      </div>
    </div>

  </div>
</div>

      <!-- Alerts BELOW card -->
      <div *ngIf="shouldShowAlert && treding" class="alert-message timingsAlert">
        Trading is closed for now. You can Trade between Monday-Friday <br>9:30 AM - 11:30 PM.
      </div>
      <div *ngIf="isLogin && isWeekendDay" class="weekend-alert text-danger">
        Trading is closed for today. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
      </div>

      <!-- Buttons BELOW card -->
      <div class="bookgold-main-btn" *ngIf="isLogin && treding">
        <button class="buy-gold-btn" *ngIf="kyc_status == 2" [style.background]="backGroundColor?.cardBackGroundColor"
          (click)="callLimit('Gold')" data-bs-toggle="modal" data-bs-target="#bookGoldModal">Book Gold</button>
        <button class="buy-gold-btn" *ngIf="kyc_status == 0" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#updateKyx">Book Gold</button>
        <button class="buy-gold-btn" *ngIf="kyc_status == 1" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#Kyxpending">Book Gold</button>
        <button class="buy-gold-btn" *ngIf="kyc_status == 3" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#Kyxrejected">Book Gold</button>

        <button class="buy-gold-btn" *ngIf="kyc_status == 2" [style.background]="backGroundColor?.cardBackGroundColor"
          (click)="callLimit('Gold')" data-bs-toggle="modal" data-bs-target="#buyGoldModalNew">Buy Gold</button>

        <button class="buy-gold-btn" *ngIf="kyc_status == 0" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#updateKyx">Buy Gold</button>
        <button class="buy-gold-btn" *ngIf="kyc_status == 1" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#Kyxpending">Buy Gold</button>
        <button class="buy-gold-btn" *ngIf="kyc_status == 3" [style.background]="backGroundColor?.cardBackGroundColor"
          data-bs-toggle="modal" data-bs-target="#Kyxrejected">Buy Gold</button>
      </div>
      <button class="new-gold-butoon" *ngIf="!isLogin">Gold</button>
    </div>

    <div class="commodity-wrapper-item">
      <!-- <div class="commodity-card silver-card">
        <div class="card-content">
     
          <p>Live Price Per kg</p>
          <div class="price silver-price" *ngIf="!socketSubscription || !livePriceSubscription; else liveSilverRate"
            [style.color]="spotSilverColor">
            ₹ {{ spotSilverUpdate }}
          </div>
          <ng-template #liveSilverRate>
            <div class="price silver-price" [style.color]="spotSilverColor">₹ {{ spotSilverUpdate }}</div>
          </ng-template>
        </div>
      </div> -->
              <div class="commodity-card-gol" *ngIf="isLogin">
          <img class="new-gold-bg-img" src="../../assets/images/silv-bg.png">
        </div>
      <div class="commodity-card silver-card">
  <div class="card-content">

    <!-- Left Content -->
    <div class="price-section">
      <p>Live Price Per Kg</p>

      <div class="price silver-price"
           [style.color]="spotSilverColor">
        ₹ {{ spotSilverUpdate }}
      </div>
    </div>

    <!-- Right Side High / Low -->
    <div class="high-low-section">
      <div class="high-box">
        H {{ silverDayHigh | number:'1.0-0' }}
      </div>

      <div class="low-box">
        L {{ silverDayLow | number:'1.0-0' }}
      </div>
    </div>

  </div>
</div>

      <!-- Alerts BELOW card -->
      <div *ngIf="shouldShowAlert && treding" class="alert-message timingsAlert silver-alert">
        Trading is closed for now. You can Trade between<br> Monday-Friday 9:30 AM - 11:30 PM.
      </div>
      <div *ngIf="isLogin && isWeekendDay" class="weekend-alert text-danger">
        Trading is closed for today. You can Trade between Monday-Friday 9:30 AM - 11:30 PM.
      </div>

      <!-- Buttons BELOW card -->
      <div class="bookgold-main-btn" *ngIf="isLogin && treding">
        <button class="book-gold-btn book-silver-btn" *ngIf="kyc_status == 2"
          [style.background]="backGroundColor?.cardBackGroundColor" (click)="callLimit('Silver')" data-bs-toggle="modal"
          data-bs-target="#bookSilverModal">Book Silver</button>
        <button class="book-gold-btn book-silver-btn" *ngIf="kyc_status == 0"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#updateKyx">Book Silver</button>
        <button class="book-gold-btn book-silver-btn" *ngIf="kyc_status == 1"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#Kyxpending">Book Silver</button>
        <button class="book-gold-btn book-silver-btn" *ngIf="kyc_status == 3"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#Kyxrejected">Book Silver</button>

        <button class="buy-gold-btn buy-silver-btn" *ngIf="kyc_status == 2"
          [style.background]="backGroundColor?.cardBackGroundColor" (click)="callLimit('Silver')" data-bs-toggle="modal"
          data-bs-target="#buyGoldModalNewSilver">Buy Silver</button>
        <button class="buy-gold-btn buy-silver-btn" *ngIf="kyc_status == 0"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#updateKyx">Buy Silver</button>
        <button class="buy-gold-btn buy-silver-btn" *ngIf="kyc_status == 1"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#Kyxpending">Buy Silver</button>
        <button class="buy-gold-btn buy-silver-btn" *ngIf="kyc_status == 3"
          [style.background]="backGroundColor?.cardBackGroundColor" data-bs-toggle="modal"
          data-bs-target="#Kyxrejected">Buy Silver</button>
      </div>
      <button class="new-silver-button" *ngIf="!isLogin">Silver</button>
    </div>






  </div>
              <div class="row mt-3 new-row">
                <p class="gold-silver-prices-para">Gold & Silver Price Trends</p>
                <div class="new-div-for-chart">
                              <div class="trend-card">

              <!-- Header layout -->
              <div class="trend-header">

                <!-- Left: title + dropdown stacked -->
                <div class="trend-header-left">
                  <span class="trend-title">Gold vs Silver Trend</span>
                  <select [(ngModel)]="selectedTimeframe" (change)="onTimeframeChange()" class="timeframe-dropdown">
                    <option value="today">Today</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                  </select>
                </div>

                <!-- Right: Gold badge, then Silver badge — stacked vertically -->
                <div class="trend-legend">
                  <!-- Gold -->
                  <span class="legend-item">
                    <span class="legend-dot gold-dot"></span>
                    <span class="legend-label">Gold</span>
                    <span class="trend-change positive" *ngIf="goldChangePercent >= 0">
                      ▲ +{{ goldChangePercent | number:'1.2-2' }}%
                    </span>
                    <span class="trend-change negative" *ngIf="goldChangePercent < 0">
                      ▼ {{ goldChangePercent | number:'1.2-2' }}%
                    </span>
                  </span>
                  <!-- Silver -->
                  <span class="legend-item">
                    <span class="legend-dot silver-dot"></span>
                    <span class="legend-label">Silver</span>
                    <span class="trend-change positive" *ngIf="silverChangePercent >= 0">
                      ▲ +{{ silverChangePercent | number:'1.2-2' }}%
                    </span>
                    <span class="trend-change negative" *ngIf="silverChangePercent < 0">
                      ▼ {{ silverChangePercent | number:'1.2-2' }}%
                    </span>
                  </span>
                </div>

              </div><!-- /trend-header -->

              <!-- Loading indicator -->
              <!-- <div class="chart-loading" *ngIf="isLoadingChart">
                <div class="spinner-border text-warning" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div> -->

              <!-- Chart container -->
              <div class="chart-container" >
                <canvas id="trendChart"></canvas>
              </div>

            </div>
                </div>
        </div>

</div>
<section class="hide-for-mobile">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <div class="socila-background-img">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-1 new-width-for-col">

              </div>
              <div class="col-md-4">
                <div class="new-card-for-content">
                  <div class="div-for-text-align-center">
                    <p class="download-parafgraph">Download Our App</p>
                    <div class="new-div-for-im-vai">
                      <img class="vaibhav-img" src="../../assets/images/bhavav.png.png">
                    </div>
                  </div>
                  <p class="stay-updated-para">Stay updated with real-time prices<br>
                    anytime, anywhere</p>
                  <div style="margin-top: 45px;">
                    <a href="https://play.google.com/store/apps/details?id=com.goldsikka.gbharath&hl=en"
                      target="_blank"><img class="playstore-img"
                        src="../../assets/images/goldbahratgoogleplay.png.png"></a>
                  </div>
                  <div style="margin-top: 10px;">
                    <a href="https://apps.apple.com/gb/app/goldbharat/id6443963704" target="_blank"><img
                        class="playstore-img" src="../../assets/images/Goldbaharatappstore.png.png"></a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- abcd -->
<section>
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <div class="new-backgroundimg-last">
          <div class="text-center">
            <p class="license-para">Licence & Certificate</p>
            <img class="img-background" src="../../assets/images/bhavav.png.png">
          </div>
          <div class="new-border-div">
            <img class="license-img" src="../../assets/images/licence-1.png.png">
            <img class="license-img" src="../../assets/images/licence-2.png.png">
            <img class="license-img" src="../../assets/images/licence-3.png.png">
            <img class="license-img" src="../../assets/images/licence-4.png.png">
            <img class="license-img" src="../../assets/images/licence-5.png.png">
          </div>
          <div class="text-center">
            <p class="contact-us-para">Contact Us</p>
            <img class="img-background" src="../../assets/images/bhavav.png.png">
          </div>
          <div class="cards-div">
            <div class="first-card">

              <div class="card-row">
                <div class="card-icon">
                  <img src="../../assets/images/Vector.png" alt="Phone">
                </div>

                <div class="card-content-new">
                  <h4 style="color:#000;font-weight:600px">Contact Number</h4>
                  <p style="color:#000">1800 8906 122 / 040 23222175</p>
                </div>
              </div>

              <div class="card-row">
                <div class="card-icon">
                  <img src="../../assets/images/on-time.svg.png" alt="Time">
                </div>

                <div class="card-content-new">
                  <h4 style="color:#000">Timings</h4>
                  <p style="color:#000">Mon - Sat : 9:30 AM to 6:30 PM</p>
                </div>
              </div>

            </div>
            <div class="first-card">

              <div class="card-row">
                <div class="card-icon">
                  <img src="../../assets/images/whatsapp.svg.png" alt="Phone">
                </div>

                <div class="card-content-new">
                  <h4 style="color:#000;font-weight:600px">WhatsApp Number</h4>
                  <p style="color:#000">+91 91600 06702</p>
                </div>
              </div>

              <div class="card-row">
                <div class="card-icon">
                  <img src="../../assets/images/gmail.svg.png" alt="Time">
                </div>

                <div class="card-content-new">
                  <h4 style="color:#000">Email ID</h4>
                  <p style="color:#000">info@goldbharat.com</p>
                </div>
              </div>

            </div>
            <div class="first-card">
              <div class="new-div">
                <img src="../../assets/images/Group 1000002883.png">
                <p class="address-paraa">Address</p>
              </div>
              <div class="text-center">
                <p style="color:#000;font-size:16px;margin-top: -15px;">XAU Gold Bharat Pvt Ltd 2nd Floor, Ashoka
                  Raghupathi Chambers, #1-10-60, Adj toPrakash Nagar Metro Station, Begumpet,Hyderabad, Telangana,
                  500016 India.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
  class="scroll-top-btn"
  [style.background]="
    'conic-gradient(#ff7a00 ' + progress + '%, #e5e5e5 ' + progress + '%)'
  "
  [class.show]="showScrollButton"
  (click)="scrollToTop()">

  <div class="inner-circle">
    ↑
  </div>

</div>
</section>

